import { FC, useState } from "react";
import FilterBar from "./FilterBar";
import Areas from "./Areas";
import { FilterBarDefaultValues } from "./StructureAreas.scheme";
import { IAreasQueryParams } from "./StructureAreas.models";

interface IStructureAreas {
  structureId: string;
}

const StructureAreas: FC<IStructureAreas> = ({ structureId }) => {
  const [queryParameters, setQueryParameters] = useState<IAreasQueryParams>(
    FilterBarDefaultValues
  );

  const updateQueryParameters = (params: IAreasQueryParams) => {
    setQueryParameters(params);
  };

  return (
    <>
      <FilterBar updateQueryParameters={updateQueryParameters} />
      <Areas
        sortType={queryParameters.sortType}
        search={queryParameters.search}
        structureId={structureId}
      />
    </>
  );
};

export default StructureAreas;
